
import React from 'react';
import SidebarNavItem from './SidebarNavItem';
import { NavItem } from './types';
import { cn } from '@/lib/utils';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useNavigationFiltering } from './hooks/useNavigationFiltering';
import { useEnhancedAuthContext } from '@/context/auth/EnhancedAuthContext';

type SidebarNavigationProps = {
  items: NavItem[];
  expanded: boolean;
  isMobile: boolean;
  expandedItems: Record<string, boolean>;
  toggleExpandItem: (title: string, event: React.MouseEvent) => void;
  handleNavigation: () => void;
};

const SidebarNavigation = ({ 
  items, 
  expanded, 
  isMobile, 
  expandedItems, 
  toggleExpandItem, 
  handleNavigation 
}: SidebarNavigationProps) => {
  const { user } = useEnhancedAuthContext();
  const filteredItems = useNavigationFiltering(items);

  // Always show navigation - don't block on loading
  // Superusers and regular users see their appropriate items immediately
  
  return (
    <div className={cn(
      "flex-1 py-6 px-3 overflow-hidden",
      "transition-all duration-300 ease-in-out"
    )}>
      <ScrollArea className="h-full pr-2">
        <div className="space-y-1.5">
          {filteredItems.map((item) => (
            <SidebarNavItem
              key={item.path}
              item={item}
              expanded={expanded}
              isMobile={isMobile}
              expandedItems={expandedItems}
              toggleExpandItem={toggleExpandItem}
              handleNavigation={handleNavigation}
            />
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};

export default SidebarNavigation;
